import * as actionTypes from './actionTypes';


export const subSourceData = (payload) => {
    //console.log("payloadSUBSOURCEDATA+++++++",payload)
    return {
        type: actionTypes.GET_SUB_SOURCE,
        subSourceArr:payload,
    }
}